import * as types from "@/store/constants/types";
import Http from "@/api/http/fetch/index";
import generalUtilsHelper from "@/utils/generalUtils";
import { initialAnalytics } from "@/utils/analytics";
import * as appLifeCycle from "@/utils/appLifeCycle";
import checkinNotiHandler from "@/components/notification/CheckinNotiHandler";
import store from "@/store";
import localStorageHelper from "@/localstorage/localstorage";
import { isIos } from "@/utils/lodash";
import getNoticeContent from "@/utils/killAppNotice.ts";
const HandleNoticeinit = async () => {
    try {
        /**
         * 1.拉取setting
         * 2.拉取feed流
         * 3.如果用户登录了需要拉取gx的user_info
         * 4.Android:需要初始化paypal的sdk
         */

        /**
         * 先跳转到Followers页面
         */

        /**
         * 支付方式阈值的初始化
         */
        const paymentSwitchInitial = () => {
            store.dispatch(types.UPDATE_PAYMENT_SWITCH_THRESHOLD);
        };

        //获取启动时间戳
        const initTime = () => {
            store.dispatch(types.INITIAL_TIME_STAMP);
        };
        initTime();

        appLifeCycle.initialListener();

        //拉取setting:
        await store.dispatch(types.REQUEST_GX_SETTING_DATA);
        //更新用户信息
        store.dispatch(types.UPDATE_GX_MASTER_SERVER_DATA);
        appLifeCycle.initialGoBackListener();

        store.commit(types.UPDATE_APP_LAUNCH_TIME); //更新app启动的次数

        store.dispatch(types.REQUEST_FEEDS); //拉取feed

        //支付方式阈值的初始化：
        paymentSwitchInitial();
        //更新DeviceId:(异步拿取必须阻塞，避免后面拿不到device))
        await store.dispatch(types.UPDATE_DEVICE_ID);

        //Google analytics:
        initialAnalytics();

        const masterId = store.getters[types.GETTER_DEVICE_ID];
        store.dispatch(types.LOGIN_BY_GX, {
            masterId
        });
        store.dispatch(types.UPDATE_GX_SERVICE_LIST);

        store.dispatch(types.UPDATE_NATIVE_LOGIN_STATUS); //告诉原生materId和登陆状态，用来推送

        store.dispatch(types.ROUTER_REPLACE, {
            name: "Followers",
            params: {
                routerTransition: "up",
                comeFromNotice: false
            }
        });
        if (generalUtilsHelper.isDoubleCoins()) {
            store.commit(types.UPDATE_DOUBLE_COIN_BUBBLE_STATUS, true);
        }

        //执行路由跳转逻辑：如果不是空账号执行跳转
        // console.log("meizhaunghao", generalUtilsHelper.isEmptyAccount());
        if (!generalUtilsHelper.isEmptyAccount()) {
            // routerPush(store.dispatch, store.getters);
            //执行账号刷新 userinfo userMedia：
            const currentUserInfo = store.getters[types.GETTER_CURRENT_INS_USER_INFO];
            store.dispatch(types.UPDATE_USER_INS_INFO, {
                userId: currentUserInfo.userId,
                username: currentUserInfo.userName
            });
            store.dispatch(types.UPDATE_USER_INS_POST, currentUserInfo.userId);
        } else {
            //如果是空账号，从其他类型的app去读取用户数据：
            // console.log("空账号，从loaduserInfo获取数据");
            Http.LoadUserInfo()
                .then((result: any) => {
                    console.log("LoadUserInfo:", result);
                    if (result && result.length > 0) {
                        store.commit(types.ADD_OTHER_APP_USER, result);
                    }
                })
                .catch((error: any) => {
                    console.log("LoadUserInfo eroor:", error);
                });
        }
        const appVersion = localStorageHelper.get("is_app_version_ok");
        //版本号小于4.0.0的不支持ShowBatchNotification方法，app到前台也不会主动注销之前的通知
        if (!appVersion) {
            setTimeout(() => {
                // console.log(
                //   "走通知，app从死的状态打开，版本号低于4.0.0，打开app 8秒后发签到通知"
                // );
                checkinNotiHandler.configNotification();
            }, 8000);
        } else {
            setTimeout(() => {
                if (isIos()) {
                    const data = getNoticeContent.calcNoticeData();
                    const toNative = data.includes("&") ? data : data + "&";
                    // console.log(toNative);
                    // Http.TerminateData(toNative);
                }
            }, 7000);
        }
    } catch (error) {
        try {
            /**
             * 先跳转到Followers页面
             */
            // console.log("执行replace路由******tryerr", "follow");
            store.dispatch(types.ROUTER_REPLACE, {
                name: "Followers",
                params: {
                    routerTransition: "up"
                }
            });
        } catch (err) {}
        console.log("INITIAL_SETTING Error:", error);
        return Promise.reject(error);
    }
};
export default HandleNoticeinit;
